import * as Logger from "js-logger";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";

export default class BannerComponent {

    public static loopTime: number = 20000;

    private modeScenes: Map<string, string[]> = new Map<string, string[]>();

    private mode: string;
    private currentScene: number = 0;

    private sceneTimeout: number;

    public addScenesForMode(mode: string, scenes: string[]) {
        this.modeScenes.set(mode, scenes);
    }

    public start() {
        this.stop();
        this.sceneTimeout = Timer.setTimeout(() => this.nextScene(), BannerComponent.loopTime);
    }

    public stop() {
        Timer.clearTimeout(this.sceneTimeout);
    }

    public setMode(mode: string) {
        const scenes = this.modeScenes.get(mode);

        if (!scenes) {
            Logger.warn("BannerComponent: Trying to show a mode which doesn't exist in config: " + mode);
            return;
        }

        if (Layers.Banners.hasScenes(scenes)) {
            this.mode = mode;
            this.currentScene = -1;

            this.nextScene();
        } else {
            throw new Error("Error: BannerComponent: Trying to show a mode which doesn't exist in the Banner layer.");
        }
    }

    public hide() {
        Layers.Banners.hide();
    }

    public show() {
        Layers.Banners.show();
    }

    private nextScene() {
        const scenes = this.modeScenes.get(this.mode);

        if (this.modeScenes.size > 1) {
            this.currentScene++;
            if (this.currentScene >= scenes.length) {
                this.currentScene = 0;
            }

            Layers.Banners.setScene(scenes[this.currentScene]).execute();
        }

        this.start();
    }
}
